<!-- Migrated from legacy/Plus/Plus/lightning_talks/index.html (2013 reveal.js deck) -->

<template>
  <h4>Lightning Talks</h4>
  <p>
    At the 2013 'Connect With Science' event, invited participants got 30 seconds and one slide
    each to introduce their work connecting science and creativity.
  </p>
  <div v-for="talk in talks" :key="talk.presenter" class="talk">
    <img :src="`/Plus/Lightning/${talk.title}`" :alt="`Title slide for ${talk.presenter}`" />
    <img :src="`/Plus/Lightning/${talk.slide}`" :alt="`Slide by ${talk.presenter}`" />
    <p>
      <strong>{{ talk.presenter }}</strong>
      <template v-if="talk.url">
        &mdash; <a :href="`https://${talk.url}`">{{ talk.url }}</a>
      </template>
    </p>
  </div>
  <h4>Additional lightning-talk slides</h4>
  <div v-for="slide in extraSlides" :key="slide" class="talk">
    <img :src="`/Plus/Lightning/${slide}`" alt="Lightning talk slide" />
  </div>
</template>

<script setup>
const talks = [
  {title: "Title01.png", slide: "Slide02.png", presenter: "Kate Patterson",
    url: "www.medipicsandprose.com.au"},
  {title: "Title02.png", slide: "Slide04.png", presenter: "Christopher Hammang",
    url: "vizbi.org/Plus"},
  {title: "Title03.png", slide: "Slide06.png", presenter: "Erica Seccombe",
    url: "www.isea2013.org/events/synapse"},
  {title: "Title04.png", slide: "christian.png", presenter: "Christian Stolte",
    url: "aquaria.ws"},
  {title: "Title05.png", slide: "Slide10.png", presenter: "Eleanor Gates-Stuart",
    url: "www.stellrscope.com"},
  {title: "Title06.png", slide: "Slide12.png", presenter: "Cheryl Li"},
  {title: "Title07.png", slide: "Wong_David1.png", presenter: "David Wong",
    url: "davidwong.photoshelter.com"},
  {title: "Title08.png", slide: "Slide16.png", presenter: "Wojciech Chrzanowski"},
  {title: "Title09.png", slide: "Slide18.png", presenter: "Tomasz Bednarz"},
  {title: "Title10.png", slide: "Slide20.png", presenter: "Sam Scopelliti",
    url: "www.samscopelliti.com"},
  {title: "Title11.png", slide: "Slide22.png", presenter: "Garry Lynch"},
  {title: "Title12.png", slide: "Slide24.png", presenter: "Derek Williamson"},
  {title: "Title13.png", slide: "Slide26.png", presenter: "Phillip Gough"},
  {title: "Title14.png", slide: "armando_faigl.png", presenter: "Armando Faigl",
    url: "www.youtube.com/user/armandohasudunga"},
  {title: "Title15.png", slide: "Slide28.png", presenter: "Kenny Sabir", url: "aquaria.ws"},
  {title: "Title16.png", slide: "Brozky_Mariala.jpg", presenter: "Mariela Brozky"}
];
const extraSlides = [
  "Lightning_talks.001-001.jpg",
  "Lightning_talks.002-001.jpg",
  "Lightning_talks.002-002.jpg",
  "Lightning_talks.002-003.jpg",
  "Lightning_talks.003-001.jpg",
  "Lightning_talks_Jess.003.jpg",
  "Lightning_talks.004-001.jpg",
  "Lightning_talks.005-001.jpg",
  "Lightning_talks.005-002.jpg",
  "Lightning_talks.005-003.jpg",
  "Lightning_talks.006-001.jpg"
];
</script>

<style scoped>
h4 {
  font-weight: 600;
  font-size: 1rem;
  margin-top: 1.5rem;
}
.talk {
  display: flex;
  flex-wrap: wrap;
  gap: 1%;
  align-items: flex-start;
  margin-bottom: 1.5rem;
}
.talk img {
  width: 49%;
  min-width: 260px;
  border-radius: 4px;
}
.talk p {
  width: 100%;
  margin: 0.3rem 0 0;
  font-size: 0.9rem;
}
</style>
